import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import axios from "axios";
import Loader from "../../components/common/Loader";
import { Form, Spinner } from "react-bootstrap"
import API_BASE_URL from "../../config/api";

const AdvanceRequestDetails = ({ requestId, onClose }) => {
    const [request, setRequest] = useState(null);
    const [paymentMethod, setPaymentMethod] = useState("");
    const [accountNumber, setAccountNumber] = useState("");
    const [remarks, setRemarks] = useState("");
    const [generalMaster, setGeneralMaster] = useState([]);
    const { token } = useContext(AuthContext);
    const [loading, setLoading] = useState(true);
    const [loadingaction, setLoadingAction] = useState(false);
    const [notification, setNotification] = useState(null);
    const role = sessionStorage.getItem("userrole");
    const [repaymentStartDate, setRepaymentStartDate] = useState("");


    useEffect(() => {
        setLoading(true);
        const token = sessionStorage.getItem("token");
        axios
            .get(`${API_BASE_URL}/api/AdvancePayment/${requestId}`, {
                headers: { Authorization: `Bearer ${token}` },
            })
            .then((res) => {
                setRequest(res.data);
            })
            .catch((err) => {
                console.error("Error fetching advance request:", err);
            })
            .finally(() => setLoading(false));
    }, [requestId]);

    useEffect(() => {

        const fetchgeneralMaster = async () => {
            const res = await fetch(`${API_BASE_URL}/api/Config/AllGeneralMaster`, {

            });
            if (res.ok) {
                const data = await res.json();
                setGeneralMaster(data);
            }
        };
        fetchgeneralMaster();

    }, [token]);

    const downloadFile = async (filePath) => {
        const response = await fetch(`${API_BASE_URL}/api/Employee/download/${filePath}`, {
            method: "GET",
            // headers: { Authorization: `Bearer ${token}` } // if needed
        });

        if (!response.ok) throw new Error("File not found or server error");

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = filePath.split("/").pop();
        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    };


    const handleAction = async (action) => {
        const token = sessionStorage.getItem("token");

        try {
            let payload = {
                requestId,
                action,
                remarks,
            };

            if (action === 84) {
                // Reject → only remarks required
                if (!remarks?.trim()) {
                    setNotification({ type: "error", message: `Remarks are required for rejection.` });
                    return;
                }
            }

            if (action === 83) {
                // Approve & Disburse → all fields required
                if (!paymentMethod || !accountNumber?.trim() || !remarks?.trim() || !repaymentStartDate) {
                    setNotification({ type: "error", message: `Please fill all fields.` });
                    return;
                }

                const accountRegex = /^[0-9]{9,18}$/; // only digits, between 9 and 18 characters (adjust as needed)
                if (!accountRegex.test(accountNumber)) {
                    setNotification({ type: "error", message: `Please enter a valid account number.` });
                    return;
                }
            }
            setLoadingAction(true);
            // Only add these for Approve (83)
            if (action === 83) {
                payload.paymentMethod = paymentMethod;
                payload.accountNumber = accountNumber.trim();
                payload.repaymentStartDate = repaymentStartDate;
                payload.remarks = remarks.trim();
            }

            if (action === 84) {
                payload.remarks = remarks.trim();
            }


            const response = await axios.post(
                `${API_BASE_URL}/api/AdvancePayment/ApproveDisburse`,
                payload,
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            onClose();
        } catch (err) {
            console.error("API Error:", err.response || err.message);
            setNotification({
                type: "error",
                message: err.response?.data?.message || "Failed to process the request.",
            });
        } finally {
            setLoadingAction(false);
        }
    };

    const closeNotification = () => setNotification(null);

    return (
        <>
            {loading ? (
                <Loader message="Loading..." />
            ) : (
                <div className="layout-content-container flex flex-col max-w-[960px] flex-1">
                    <div className="flex flex-wrap justify-between gap-3 p-4">
                        <p className="text-[#121516] tracking-light text-[32px] font-bold leading-tight min-w-72">
                            Advance Payment Request
                        </p>
                    </div>

                    {/* Request details */}
                    <h3 className="text-lg font-bold px-4 pb-2 pt-4">Request Details</h3>
                    <div className="p-4 grid grid-cols-[20%_1fr] gap-x-6">
                        <div className="col-span-2 grid grid-cols-subgrid border-t py-5">
                            <p className="text-[#6a7881] text-sm">Employee</p>
                            <p className="text-[#121516] text-sm">{request.employeeName}</p>
                        </div>
                        <div className="col-span-2 grid grid-cols-subgrid border-t py-5">
                            <p className="text-[#6a7881] text-sm">Request Date</p>
                            <p className="text-[#121516] text-sm">{new Date(request.requestDate).toLocaleDateString()}</p>
                        </div>
                        <div className="col-span-2 grid grid-cols-subgrid border-t py-5">
                            <p className="text-[#6a7881] text-sm">Amount Requested</p>
                            <p className="text-[#121516] text-sm">
                                ₹{Number(request.amountRequested || 0).toLocaleString("en-US")}
                            </p>
                        </div>
                        <div className="col-span-2 grid grid-cols-subgrid border-t py-5">
                            <p className="text-[#6a7881] text-sm">Repayment Plan</p>
                            <p className="text-[#121516] text-sm">{request.repaymentPlan}</p>
                        </div>
                        <div className="col-span-2 grid grid-cols-subgrid border-t py-5">
                            <p className="text-[#6a7881] text-sm">Reason</p>
                            <p className="text-[#121516] text-sm">{request.reason}</p>
                        </div>
                        {request.attachmentPath && (
                            <div className="col-span-2 grid grid-cols-subgrid border-t py-5">
                                <p className="text-[#6a7881] text-sm">Attachment</p>
                                <a
                                    onClick={() => downloadFile(request.attachmentPath)}
                                    download
                                    className="text-blue-600 hover:underline text-sm font-medium cursor-pointer"
                                >
                                    Download
                                </a>
                            </div>
                        )}
                        {request.statusId !== 75 && (
                            <div className="col-span-2 grid grid-cols-subgrid border-t py-5">
                                <p className="text-[#6a7881] text-sm">Status</p>
                                <span
                                    className={`text-sm font-medium
                                      ${request.statusId === 76 ? "text-green-700" : ""}
                                      ${request.statusId === 84 ? "text-red-700" : ""}
                                      ${request.statusId === 83 ? "text-green-700" : ""}
                                    `}
                                >
                                    {request.status}
                                </span>
                            </div>
                        )}
                    </div>

                    {role === "1" && request.statusId === 75 && (
                        <>
                            {/* Payment disbursement */}
                            <h3 className="text-lg font-bold px-4 pb-2 pt-4">Payment Disbursement</h3>

                            {notification && (
                                <div
                                    className={`mx-4 p-4 rounded ${notification.type === "error"
                                        ? "bg-red-100 text-red-700"
                                        : "bg-green-100 text-green-700"
                                        }`}
                                >
                                    <div className="flex justify-between items-center">
                                        <span>{notification.message}</span>
                                        <button onClick={closeNotification} className="font-bold text-xl leading-none">
                                            ×
                                        </button>
                                    </div>
                                </div>
                            )}

                            <div className="flex max-w-[480px] flex-wrap items-end gap-4 px-4 py-3">
                                <label className="flex flex-col min-w-40 flex-1">
                                    <p className="text-base font-medium pb-2">Payment Method</p>
                                    <select
                                        className="form-input h-14 rounded-xl border p-[15px]"
                                        value={paymentMethod}
                                        onChange={(e) => setPaymentMethod(e.target.value)}
                                    >
                                        <option value="">Select</option>
                                        {generalMaster
                                            .filter((x) => x.mainId == 80)
                                            .map((opt) => (
                                                <option key={opt.id} value={opt.id}>
                                                    {opt.title}
                                                </option>
                                            ))}
                                    </select>
                                </label>
                            </div>

                            <div className="flex max-w-[480px] flex-wrap items-end gap-4 px-4 py-3">
                                <label className="flex flex-col min-w-40 flex-1">
                                    <p className="text-base font-medium pb-2">Account Number</p>
                                    <input
                                        className="form-input h-14 rounded-xl border p-[15px]"
                                        value={accountNumber}
                                        onChange={(e) => setAccountNumber(e.target.value)}
                                    />
                                </label>
                            </div>

                            <div className="flex max-w-[480px] flex-wrap items-end gap-4 px-4 py-3">
                                <label className="flex flex-col min-w-40 flex-1">
                                    <p className="text-base font-medium pb-2">Repayment Start Date</p>
                                    <input
                                        type="date"
                                        min={new Date().toISOString().split("T")[0]}
                                        className="form-input h-14 rounded-xl border p-[15px]"
                                        value={repaymentStartDate}
                                        onChange={(e) => setRepaymentStartDate(e.target.value)}
                                    />
                                </label>
                            </div>

                            <div className="flex max-w-[480px] flex-wrap items-end gap-4 px-4 py-3">
                                <label className="flex flex-col min-w-40 flex-1">
                                    <p className="text-base font-medium pb-2">Remarks</p>
                                    <textarea
                                        className="form-input rounded-xl border p-[15px]"
                                        value={remarks}
                                        onChange={(e) => setRemarks(e.target.value)}
                                    />
                                </label>
                            </div>

                            <div className="flex justify-stretch">
                                <div className="flex flex-1 gap-3 flex-wrap px-4 py-3 justify-end">
                                    <button
                                        onClick={() => handleAction(84)}
                                        className="btn-danger"
                                    >
                                        {
                                            loadingaction ?
                                                <div className="flex justify-center"><Spinner animation="border" size="sm" style={{ width: '1rem', height: '1rem' }} />Loading...</div>
                                                :
                                                'Reject'
                                        }
                                    </button>
                                    <button
                                        onClick={() => handleAction(83)}
                                        className="btn-black"
                                    >
                                        {
                                            loadingaction ?
                                                <div className="flex justify-center"><Spinner animation="border" size="sm" style={{ width: '1rem', height: '1rem' }} />Loading...</div>
                                                :
                                                'Approve & Disburse'
                                        }
                                    </button>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            )}
        </>
    );
};

export default AdvanceRequestDetails;